import lottie from "lottie-web/build/player/lottie_light";
import React, { ReactElement, useEffect } from "react";

interface Props {
    autoplay: boolean;
    loop: boolean;
    src: string;
    className?: string;
}

export default function Player(props: Props): ReactElement {
    const ref = React.createRef<HTMLDivElement>();
    useEffect(() => {
        if (ref.current) {
            try {
                lottie.loadAnimation({
                    container: ref.current,
                    animationData: props.src.startsWith("/") ? undefined : props.src,
                    path: props.src.startsWith("/") ? props.src : undefined,
                    loop: props.loop,
                    autoplay: props.autoplay,
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        }
    }, [ref.current]);
    return (
        <div ref={ref} className={props.className} />
    );
}

Player.defaultProps = {
    className: "",
};
